import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    TextField,
    Button,
    MenuItem,
    FormControlLabel,
    Checkbox,
    Typography,
    Alert,
} from "@mui/material";
import { useState } from "react";
import React from "react";
import {useInviteMember} from "../../data/invitations";
import {apiErrorMessage} from "../../utilities/apiError";
import {BoardRole} from "../../types/task";

export default function InviteMemberDialog({
                                boardId,
                                open,
                                onClose,
                            }: {
    boardId: string;
    open: boolean;
    onClose: () => void;
}) {
    const [email, setEmail] = useState("");
    const [role, setRole] = useState<Exclude<BoardRole, "owner">>("editor");
    const [kiosk, setKiosk] = useState(false);

    const inviteMutation = useInviteMember(boardId);

    function handleInvite() {
        inviteMutation.reset();
        inviteMutation.mutate({email, role, kiosk}, {
            onSuccess: () => {
                setEmail("");
                setRole("editor");
                setKiosk(false);
                onClose();
            },
        });
    }

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>Invite to board</DialogTitle>

            <DialogContent>
                <Typography variant="body2" color="text.secondary" sx={{mb: 1}}>
                    They'll get an invitation to accept. They can't see this board until they do.
                </Typography>

                <TextField
                    autoFocus
                    margin="dense"
                    label="Email address"
                    type="email"
                    fullWidth
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />

                <TextField
                    select
                    margin="dense"
                    label="Role"
                    fullWidth
                    value={role}
                    onChange={(e) => setRole(e.target.value as any)}
                >
                    <MenuItem value="viewer">Viewer</MenuItem>
                    <MenuItem value="assignee">Assignee</MenuItem>
                    <MenuItem value="editor">Editor</MenuItem>
                </TextField>

                <FormControlLabel
                    control={
                        <Checkbox
                            checked={kiosk}
                            onChange={(e) => setKiosk(e.target.checked)}
                        />
                    }
                    label="Kiosk mode"
                />
                <Typography variant="caption" color="text.secondary" display="block">
                    Once they accept, this restricts them to only this board — they won't see the board list or be able to switch to any other board, even ones they're otherwise invited to.
                </Typography>

                {inviteMutation.isError && (
                    <Alert severity="error" sx={{mt: 2}}>{apiErrorMessage(inviteMutation.error)}</Alert>
                )}
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button
                    variant="contained"
                    disabled={!email || inviteMutation.isPending}
                    onClick={handleInvite}
                >
                    Send invitation
                </Button>
            </DialogActions>
        </Dialog>
    );
}